import React from 'react';
import { Box, Typography, Chip, Paper } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

interface PlaceholderLegendProps {
  onInsert?: (placeholder: string) => void;
}

const placeholders = [
  { tag: '{PRODUCT_LINK}', desc: 'Landing-URL mit Tracking (erforderlich)', required: true },
  { tag: '{PRODUCT_NAME}', desc: 'Produktname' },
  { tag: '{PRODUCT_CODE}', desc: 'Produktcode (TAM, TST, etc.)' },
  { tag: '{EMAIL}', desc: 'E-Mail-Adresse des Empfängers' },
  { tag: '{DATE:d.m.Y}', desc: 'Aktuelles Datum formatiert' },
];

const PlaceholderLegend: React.FC<PlaceholderLegendProps> = ({ onInsert }) => {
  const handleClick = (placeholder: string) => {
    if (onInsert) {
      onInsert(placeholder);
    } else {
      navigator.clipboard.writeText(placeholder);
    }
  };

  return (
    <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#f5f5f5' }}>
      <Typography variant="subtitle2" gutterBottom>
        Verfügbare Platzhalter (klicken zum Einfügen):
      </Typography>
      <Box display="flex" flexWrap="wrap" gap={1}>
        {placeholders.map((p, idx) => (
          <Chip
            key={idx}
            label={
              <Box display="flex" alignItems="center" gap={0.5}>
                <code style={{ fontFamily: 'monospace' }}>{p.tag}</code>
                <Typography variant="caption" color="textSecondary">
                  {p.desc}
                </Typography>
              </Box>
            }
            onClick={() => handleClick(p.tag)}
            variant={p.required ? 'filled' : 'outlined'}
            color={p.required ? 'primary' : 'default'}
            sx={{ height: 'auto', py: 0.5 }}
            icon={<ContentCopyIcon fontSize="small" />}
          />
        ))}
      </Box>
    </Paper>
  );
};

export default PlaceholderLegend;
